import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import duration from 'dayjs/plugin/duration';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);

export const useDayjs = (
  props?: string | number | dayjs.Dayjs | Date | null | undefined
): dayjs.Dayjs => dayjs(props).tz('Australia/Melbourne');
